import React from 'react'
import { AppHOC, AppProps } from './AppHOC'

const OverviewContainer = React.lazy(() => import('@components/Overview/OverviewContainer'))

export const OverviewApp: React.FC<AppProps> = props => {
  const { widgetContext } = props
  return (
    <AppHOC widgetContext={widgetContext}>
      <OverviewContainer />
    </AppHOC>
  )
}
